import { Button } from "semantic-ui-react";
import  { PDFDownloadLink, PDFViewer } from '@react-pdf/renderer';
import { OrderPdfDocument } from "./OrderPdfDocument";
import { css } from "@emotion/react";
import { I18nextProvider, useTranslation } from "react-i18next";
import useFeature from '../../../Shared/FeatureProvider/useFeature';

export const OrderPdfPrintButton = ({order}) => {

    const {isEnabled} = useFeature();
    const {t,ready,i18n } = useTranslation(undefined,{ useSuspense: false });

    if(!ready || !isEnabled('order_print_pdf')) {
        return null;
    }
    return (
        <PDFDownloadLink
            document={<I18nextProvider i18n={i18n}><OrderPdfDocument order={order} /></I18nextProvider>}
            fileName={`order_${order.displayId}.pdf`}>
                {({ blob, url, loading, error }) => (loading ? null : <Button
                icon="file pdf outline"
                      basic
                      color='teal'>
                        {t('order.pdf.download_button_label')}
                    </Button>
                )}
        </PDFDownloadLink>
    )
};

export const OrderPdfPreview = ({order}) => {
    const {ready,i18n } = useTranslation(undefined,{ useSuspense: false });
    if(!ready) {
        return null;
    }
    return (
        <div css={css`  
            width: 100%;
            height: 1000px; 
        `}>
            <PDFViewer style={{width: '100%', height: '100%'}}>
                <I18nextProvider i18n={i18n}>
                    <OrderPdfDocument order={order} />
                </I18nextProvider>
            </PDFViewer>
        </div>

    )
}
